import { useQuery } from "@tanstack/react-query";
import { apiWithoutCamelization } from "../../../api";
import urls from "../../../urls";
import type { Paragraph6FinancialDocument } from "../Paragraph6.types";
import { FinancialDocumentType } from "../Paragraph6.types";

export function useParagraph6Credits(variantId: number) {
  const {
    data: credits,
    isLoading,
    error
  } = useQuery({
    queryKey: ["paragraph6Credits", { variantId }],
    queryFn: () => fetchParagraph6Credits(variantId)
  });

  return {
    credits,
    isLoading,
    error
  };
}

async function fetchParagraph6Credits(variantId: number) {
  const url = urls.apiWithoutCamelization.paragraph6VariantCredits(variantId);
  const response =
    await apiWithoutCamelization.get<Array<Paragraph6FinancialDocument>>(url);
  return response.data.map((doc) => ({
    ...doc,
    type: doc.is_payment_information
      ? FinancialDocumentType.PaymentInformation
      : FinancialDocumentType.Credit
  }));
}
